import React, { useMemo, useState } from 'react';
import {
  ButtonToolbar,
  DropdownButton,
  FormControl,
  MenuItem,
} from 'react-bootstrap';
import styles from './GroupSearchSelect.module.css';

function GroupSearchSelect({
  groups,
  selectedGroups,
  onSelectGroup,
  onClearAll,
  disabled = false,
  showArchived = false,
  disabledGroupIds = [],
  title = 'Select Groups',
  style = {},
  className = '',
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const selectedCount = Object.keys(selectedGroups).length;

  const handleSelect = (group) => {
    onSelectGroup(group);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleToggle = (open) => {
    setIsOpen(open);
    if (!open) {
      setSearchTerm('');
    }
  };

  const filterGroupsRecursively = (groupList, searchTerm) => {
    if (!searchTerm.trim()) return groupList;

    return groupList.reduce((filtered, group) => {
      const matchesSearch = group.name
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const filteredChildren = filterGroupsRecursively(
        group.children || [],
        searchTerm
      );

      if (matchesSearch || filteredChildren.length > 0) {
        filtered.push({
          ...group,
          children: filteredChildren,
        });
      }

      return filtered;
    }, []);
  };

  const filteredGroups = useMemo(() => {
    return filterGroupsRecursively(groups, searchTerm);
  }, [groups, searchTerm]);

  const renderMenuItem = (group) => {
    if (!showArchived && group.archived) return null;

    const isSelected = group.id in selectedGroups;
    const isDisabled = disabledGroupIds.includes(group.id);

    return (
      <React.Fragment key={group.id}>
        <MenuItem
          active={isSelected}
          onSelect={() => handleSelect(group)}
          disabled={isDisabled}
        >
          <span className={group.archived && !isSelected ? 'text-muted' : ''}>
            {group.archived ? `${group.name} (archived)` : group.name}
          </span>
        </MenuItem>
        {group.children && group.children.length > 0 && (
          <li>
            <ul className={styles.groupsFilterSubmenu}>
              {group.children.map(renderMenuItem)}
            </ul>
          </li>
        )}
      </React.Fragment>
    );
  };

  return (
    <div className={styles.groupSearchSelect}>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          id="group-search-select"
          title={title || `${selectedCount} groups selected`}
          className={`btn-block ${className}`}
          style={style}
          disabled={disabled}
          pullRight
          open={isOpen}
          onToggle={handleToggle}
        >
          <MenuItem header>
            <FormControl
              type="text"
              placeholder="Search groups..."
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ margin: '5px 10px', width: 'calc(100% - 20px)' }}
            />
          </MenuItem>
          <MenuItem divider />
          {onClearAll && (
            <React.Fragment>
              <MenuItem active={selectedCount === 0} onSelect={onClearAll}>
                All
              </MenuItem>
              <MenuItem divider />
            </React.Fragment>
          )}
          {filteredGroups.length > 0 ? (
            filteredGroups.map(renderMenuItem)
          ) : (
            <MenuItem disabled>
              <span className="text-muted">No groups found</span>
            </MenuItem>
          )}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default GroupSearchSelect;
